/** @jsx jsx */
import {jsx, css} from '@emotion/core'
import vars from '../styles/vars'
import trashPanda from '../images/trash-panda.svg'

const DividerPanda = () => (
    <div
        css={css`
            margin: 15rem 0 8rem;
            border-bottom: 1px solid ${vars.black};
            text-align: right;
            width: 100%;
            position: relative;
        `}
    >
        <img
            css={css`
                max-width: 26rem;
                position: absolute;
                margin: auto;
                bottom: -3.5rem;
                right: 50%;
                transform: translateX(50%);

                @media (min-width: ${vars.bpLargerThanDesktop}) {
                    right: 22rem;
                    max-width: 30rem;
                    bottom: -4.1rem;
                }
            `}
            src={trashPanda}
            alt="A racoon waving hello"
        />
    </div>
)

export default DividerPanda
